// Owner-distribution tax helpers for the report Summary section.
//
// NOTE: the income-tax brackets are Greek personal-income rules and really belong in
// the backend service layer (they will drift from the law otherwise). They live here
// only because that is where they were; moving them server-side is tracked separately.
// Keep these behaviour-identical to the values shown to clients — see the tests.

// Greek marginal income tax on 95% of the income, across three brackets.
export const computeTax = (income: number): number => {
    let taxableIncome = 0.95 * income;
    const taxBrackets: [number, number][] = [
        [35001, 0.4],
        [12001, 0.35],
        [0, 0.15],
    ];
    let tax = 0;
    for (const [bracket, rate] of taxBrackets) {
        if (taxableIncome > bracket) {
            tax += (taxableIncome - bracket) * rate;
            taxableIncome = bracket;
        }
    }
    return Math.round(tax);
};

// Rounds a per-apartment figure to whole euros, halving it first when the apartment
// has two owners (a 50/50 split).
export const computeStat = (stat: number, isFiftyPc: boolean): number => {
    return Math.round(isFiftyPc ? stat / 2 : stat);
};
